module.exports = __webpack_public_path__ + "img/m-banner-ltwjyxtc-ar-SA.3ae9fbc1.jpg";